import { createLucideIcon } from 'lucide-react';
export const PostalCodeIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M12 11.5V19.766',
      key: '1wvf64',
    },
  ],
  [
    'path',
    {
      d: 'M5.5 10.1328H18.5',
      key: '1iss8v',
    },
  ],
  [
    'path',
    {
      d: 'M5.5 6H18.5',
      key: '189s1x',
    },
  ],
]);
